import type { FunctionComponent } from 'react';
import { useEffect, useState } from 'react';

import { addIdleTask, clearIdleTask } from '@trello/idle-task-scheduler';

import type { BoardDisplayAdsContainerProps } from './BoardDisplayAdsContainer';
import { LazyBoardDisplayAdsContainer } from './LazyBoardDisplayAdsContainer';

export const DeferredBoardDisplayAdsContainer: FunctionComponent<
  BoardDisplayAdsContainerProps
> = (props) => {
  const [renderAdComponent, setRenderAdComponent] = useState<boolean>(false);

  useEffect(() => {
    const taskId = addIdleTask(() => {
      setRenderAdComponent(true);
    });

    return () => {
      clearIdleTask(taskId);
    };
  }, []);

  if (renderAdComponent) {
    return <LazyBoardDisplayAdsContainer {...props} />;
  }

  return null;
};
